import { createFileRoute } from "@tanstack/react-router"
import { useEffect, useState } from "react"
import { ClientHeader } from "@/components/client-header"
import { ClientTabNavigation } from "@/components/client-tab-navigation"
import { Page } from "@/components/page"
import { EstateWaterfall } from "@/components/professional/estateWaterfall"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { EstateNextSteps, EstateNextStepsSkeleton } from "@/components/widgets/estate-next-steps"
import { EstatePlanningChecklist } from "@/components/widgets/estate-planning-checklist"
import {
  EstateReadinessScore,
  EstateReadinessScoreSkeleton,
} from "@/components/widgets/estate-readiness-score"
import { EstateSummaryCards } from "@/components/widgets/estate-summary-cards"
import { TasksPanel } from "@/components/widgets/tasks-panel"

export const Route = createFileRoute("/_authed/_professional/professional/overview/$estateId")({
  component: RouteComponent,
})

function RouteComponent() {
  const { estateId } = Route.useParams()

  const [isReadinessLoading, setIsReadinessLoading] = useState(true)
  const [isNextStepsLoading, setIsNextStepsLoading] = useState(true)

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setIsReadinessLoading(false)
    }, 1500)

    return () => window.clearTimeout(timeout)
  }, [])

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setIsNextStepsLoading(false)
    }, 2200)

    return () => window.clearTimeout(timeout)
  }, [])

  return (
    <Page
      showMobileNavigation={false}
      headerSlot={
        <ClientHeader
          estateId={estateId}
          mobileNavigationSlot={
            <SidebarTrigger className="size-10 shrink-0 md:hidden" aria-label="Open navigation" />
          }
        />
      }
      tabSlot={<ClientTabNavigation estateId={estateId} />}
    >
      <div className="space-y-6">
        <EstateSummaryCards estateId={estateId} variant="professional" />
        <div className="grid gap-6 lg:grid-cols-2">
          {isReadinessLoading ? (
            <EstateReadinessScoreSkeleton />
          ) : (
            <EstateReadinessScore estateId={estateId} variant="professional" />
          )}

          {isNextStepsLoading ? (
            <EstateNextStepsSkeleton />
          ) : (
            <EstateNextSteps estateId={estateId} variant="professional" />
          )}
        </div>

        <div className="grid items-stretch gap-6 xl:grid-cols-3">
          <div className="xl:col-span-2">
            <EstateWaterfall estateId={estateId} variant="legacy" />
          </div>

          <TasksPanel estateId={estateId} />
        </div>
        <EstatePlanningChecklist estateId={estateId} />
      </div>
    </Page>
  )
}
